import { NextPage } from 'next';
import Head from 'next/head';
import { useTranslation } from 'next-i18next';
import MobileWebViewHeader from 'src/common/components/MobileWebViewHeader';
import { loadTranslations } from 'src/common/utils/serverSidePropsHelpers';
import Header from '../../src/common/components/Header';
import Layout from '../../src/common/components/Layout';
import DescriptionMetaTag from '../../src/common/components/MetaTags/DescriptionMetaTag';
import { AuthUserApiResponse } from '../../src/common/types/api/v4/auth/user';
import serverGetUser from '../../src/common/utils/serverGetUser';
import handleApiErrors from '../../src/common/utils/handleApiErrors';
import AcceptPanel from '../../src/content/Legal/AcceptPanel';
import Terms from '../../src/content/Legal/Terms';
import withCommonMiddleware from '../../src/common/utils/withCommonMiddleware';

type TermsPageProps = {
  user: Partial<AuthUserApiResponse>;
};

const TermsPage: NextPage = () => {
  const [t] = useTranslation('legal-terms');
  return (
    <>
      <Head>
        <title>{t('title')}</title>
      </Head>
      <DescriptionMetaTag
        content={t('meta-description')}
      />
      <Layout>
        <MobileWebViewHeader />
        <Header />
        <Terms />
        <AcceptPanel />
      </Layout>
    </>
  );
};

export const getServerSideProps = handleApiErrors(
  withCommonMiddleware<TermsPageProps>(
    async (context) => ({
      props: {
        user: await serverGetUser(context),
        ...await loadTranslations(
          context.locale,
          [
            'common',
            'legal-terms',
            'navbar',
            'destination-navigation',
          ],
        ),
      },
    }),
  ),
);

export default TermsPage;
